/**
* 基础菜单 授权码验证记录
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.upload_key" placeholder="输入部分或全部授权码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" sortable prop="id" label="id" width="60">
      </el-table-column>
      <el-table-column align="center" sortable prop="upload_key" label="上传密钥" width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="context" label="上下文" min-width="500">
      </el-table-column>
      <el-table-column align="center" sortable prop="error" label="信息" width="300">
      </el-table-column>
      <el-table-column align="center" sortable prop="app_name" label="App" width="80">
      </el-table-column>
      <el-table-column align="center" sortable prop="app_version" label="Version" width="60">
      </el-table-column>
      <el-table-column align="center" sortable prop="create_time" label="生成时间" width="140">
        <!--        <template slot-scope="scope">-->
        <!--          <div>{{scope.row.editTime|timestampToTime}}</div>-->
        <!--        </template>-->
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {getRecordList} from '../../api/errorMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false, //是显示加载
      rules: {
        deptName: [
          {required: true, message: '请选择状态', trigger: 'blur'}
          //   {required: true, message: '请输入部门名称', trigger: 'blur'}
          // ],
          // deptNo: [{required: true, message: '请输入部门代码', trigger: 'blur'}
        ]
      },
      formInline: {
        upload_key: '',
        status: -1,
        pageNo: 1,
        pageSize: 10
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getRecordList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== 0) {
            if (res.code === 401) {
              setTimeout(() => {
                this.$store.commit('logout', 'false')
                this.$router.push({ path: '/login' })
                this.$message({
                  type: 'warning',
                  message: '登录失效，请重新登陆!'
                })
              }, 1000)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          } else {
            this.listData = res.data.rows
            // 分页赋值
            this.pageparm.currentPage = res.data.pageNo
            this.pageparm.pageSize = res.data.pageSize
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/errors/Errors.vue